import path from 'path';
import Debug from '../helpers/debug.js';
import YAML from 'yaml';
import Table from 'cli-table';
import { getProfileConfig, getProjectConfig } from '../helpers/config.js';
import { cl, pp, pr, themed } from '../helpers/print.js';
import { config } from './config/index.js';

const debug = Debug('commands:config');

const command = 'config [action]';

const desc = 'Configure your hotglue CLI';

const builder = async function (yargs) {
  debug('builder', command);
  return yargs.command(config);
};

const handler = async function (argv) {
  debug('handler', command, argv);

  const { action } = argv;

  // implement using yarg default command
  if (!action) {
    try {
      const profileConfig = await getProfileConfig();
      if (!profileConfig.config || Object.keys(profileConfig.config).length === 0) {
        pr('No profile configuration found. Run config set to configure the hotglue CLI.');
      }

      const table = new Table({ head: ['Setting', 'Value', 'Config File', 'Type'] });
      if (profileConfig.config)
        Object.entries(profileConfig.config).forEach(([k, v]) => table.push([k, v, profileConfig.filepath, `Profile`]));

      const projectConfig = await getProjectConfig();
      if (projectConfig.config)
        Object.entries(projectConfig.config).forEach(([k, v]) =>
          table.push([k, v, path.relative(process.cwd(), projectConfig.filepath), 'Project'])
        );

      if (table.length > 0) {
        // pr('CURRENT CONTEXT SETTINGS');
        console.log(table.toString());
        // console.log(YAML.stringify(fileConfig.config));
      }

      // pr('The configuration file is empty. Run config set to configure the hotglue CLI.');
    } catch (err) {
      // log elsewhere
      console.log(err);
      throw err;
    }
  }
};

export { command, desc, builder, handler };
